'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

export default function AosFixe() {
  const pathname = usePathname();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    // Skip on first render
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    // This runs after route change
    document.body.style.overflow = 'auto';
  }, [pathname]);

  return null;
}